const surchargesComparisonRecordResponseToSurchargesComparisonRecordObject = (response) => {
    return {
      userId: response.record_user_id,
      integrationId: response.integration_id,
      lineNumber: response.record_line_number,
      trackingNumber: response.record_tracking_number,
      externalOrderId: response.record_external_order_id,
      shipmentDate: response.record_shipment_date,
      recordCarrier: response.record_carrier,
      recordService: response.record_service,
      recordBaseChargeAmount: response.record_base_charge_amount,
      recordTotalChargeAmount: response.record_total_charge_amount,
      recordZoneRated: response.record_zone_rated,
      recordZone: response.record_zone,

      addressCorrectionFee: response.address_correction_fee,
      carbonOffsetFee: response.carbon_offset_fee,
      carrierPackagingFee: response.carrier_packaging_fee,
      codFee: response.cod_fee,
      customsDutiesTaxesFee: response.customs_duties_taxes_fee,
      dangerousGoodsFee: response.dangerous_goods_fee,
      deliveryConfirmationFee: response.delivery_confirmation_fee,
      dasFee: response.das_fee,
      fuelSurcharge: response.fuel_surcharge,
      handlingFee: response.handling_fee,
      insuredValueFee: response.insured_value_fee,
      latePaymentFee: response.late_payment_fee,
      oversizeFee: response.oversize_fee,
      peakSurchargeFee: response.peak_surcharge_fee,
      residentialSurcharge: response.residential_surcharge,
      saturdaySundayFee: response.saturday_sunday_fee,
      signatureRequiredFee: response.signature_required_fee,
      thirdPartyFee: response.third_party_fee,
      variousFees: response.various_fees,

      rateCarrier: response.rate_carrier,
      rateService: response.rate_service,
      ratePriceType: response.rate_price_type,
      rateZoneRated: response.rate_zone_rated,
      rateZone: response.rate_zone,
      rateBaseChargeAmount: response.rate_base_charge_amount,

      rateAddressCorrectionFee: response.rate_address_correction_fee,
      rateCarbonOffsetFee: response.rate_carbon_offset_fee,
      rateCarrierPackagingFee: response.rate_carrier_packaging_fee,
      rateCodFee: response.rate_cod_fee,
      rateCustomsDutiesTaxesFee: response.rate_customs_duties_taxes_fee,
      rateDangerousGoodsFee: response.rate_dangerous_goods_fee,
      rateDeliveryConfirmationFee: response.rate_delivery_confirmation_fee,
      rateDasFee: response.rate_das_fee,
      rateFuelSurcharge: response.rate_fuel_surcharge,
      rateHandlingFee: response.rate_handling_fee,
      rateInsuredValueFee: response.rate_insured_value_fee,
      rateLatePaymentFee: response.rate_late_payment_fee,
      rateOversizeFee: response.rate_oversize_fee,
      ratePeakSurchargeFee: response.rate_peak_surcharge_fee,
      rateResidentialSurcharge: response.rate_residential_surcharge,
      rateSaturdaySundayFee: response.rate_saturday_sunday_fee,
      rateSignatureRequiredFee: response.rate_signature_required_fee,
      rateThirdPartyFee: response.rate_third_party_fee,
      rateVariousFees: response.rate_various_fees,
    };
  };
  
  export { surchargesComparisonRecordResponseToSurchargesComparisonRecordObject };
